import cn from 'classnames';

import styles from './styles.module.scss';

export default function AnimatedSpinner() {
  // Define all dot positions with even spacing (6px between centers)
  const dots = [
    // Column 0 (4 dots) - starts at bottom
    { id: 0, x: 3, y: 3, column: 0 },
    { id: 1, x: 3, y: 15, column: 0 },
    { id: 2, x: 3, y: 27, column: 0 },
    { id: 3, x: 3, y: 39, column: 0 },

    // Column 1 (3 dots) - centered vertically
    { id: 4, x: 9, y: 9, column: 1 },
    { id: 5, x: 9, y: 21, column: 1 },
    { id: 6, x: 9, y: 33, column: 1 },

    // Column 2 (4 dots) - starts at bottom
    { id: 7, x: 15, y: 3, column: 2 },
    { id: 8, x: 15, y: 15, column: 2 },
    { id: 9, x: 15, y: 27, column: 2 },
    { id: 10, x: 15, y: 39, column: 2 },

    // Column 3 (3 dots) - centered vertically
    { id: 11, x: 21, y: 9, column: 3 },
    { id: 12, x: 21, y: 21, column: 3 },
    { id: 13, x: 21, y: 33, column: 3 },

    // Column 4 (4 dots) - starts at bottom
    { id: 14, x: 27, y: 3, column: 4 },
    { id: 15, x: 27, y: 15, column: 4 },
    { id: 16, x: 27, y: 27, column: 4 },
    { id: 17, x: 27, y: 39, column: 4 },

    // Column 5 (3 dots) - centered vertically
    { id: 18, x: 33, y: 9, column: 5 },
    { id: 19, x: 33, y: 21, column: 5 },
    { id: 20, x: 33, y: 33, column: 5 },

    // Column 6 (4 dots) - starts at bottom
    { id: 21, x: 39, y: 3, column: 6 },
    { id: 22, x: 39, y: 15, column: 6 },
    { id: 23, x: 39, y: 27, column: 6 },
    { id: 24, x: 39, y: 39, column: 6 },
  ];

  // Define step groups
  const stepGroups = {
    First: [], // First step dots
    Second: [5, 8, 9, 11, 12, 13, 15, 16, 19], // Second step dots
    Third: [1, 2, 4, 5, 6, 7, 8, 9, 10, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23], // Third step dots
    Fourth: [0, 1, 2, 3, 4, 6, 7, 10, 14, 17, 18, 20, 21, 22, 23, 24], // Fourth step dots
  };

  return (
    <div className="relative">
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        className="w-16 h-16"
      >

        {dots.map(dot => {
          let highlightClass = '';

          if (stepGroups.First.includes(dot.id)) {
            highlightClass = styles['highlight1'];
          }
          else if (stepGroups.Second.includes(dot.id)) {
            highlightClass = styles['highlight2'];
          }
          else if (stepGroups.Third.includes(dot.id)) {
            highlightClass = styles['highlight3'];
          }
          else if (stepGroups.Fourth.includes(dot.id)) {
            highlightClass = styles['highlight4'];
          }

          return (
            <circle
              key={dot.id}
              cx={dot.x}
              cy={dot.y}
              r="2"
              className={cn(styles['dot'], highlightClass)}
            />
          );
        })}
      </svg>
    </div>
  );
}
